import { Component, Input } from '@angular/core';
import {
  GrundstueckId,
  PfandrechtMasterDetailEntryMeta,
  RechtVersionId,
  StandardrechtMasterDetailEntryMeta
} from '../../../../core/gb-api';
import { RechtRubrik } from './recht-rubrik';
import { RubrikComponent } from '../../../../shared/components/rubrik/rubrik.component';
import { StandardrechtBelastungenComponent } from '../../standardrecht/standardrecht-belastungen/standardrecht-belastungen.component';
import { RechtPerimeterComponent } from '../../recht-perimeter/recht-perimeter.component';
import { HaengigeGeschaefteAuftraegeComponent } from '../../../../shared/components/haengige/haengige-geschaefte/haengige-geschaefte-auftraege.component';
import { PfandrechtBelastungenComponent } from '../../pfandrecht/pfandrecht-belastungen/pfandrecht-belastungen.component';
import { PfandrechtGlaeubigerComponent } from '../../pfandrecht/pfandrecht-glaeubiger/pfandrecht-glaeubiger.component';
import { PfandrechtSchuldnerComponent } from '../../pfandrecht/pfandrecht-schuldner/pfandrecht-schuldner.component';
import { PfandrechtCapititelComponent } from '../../pfandrecht/pfandrecht-pfandtitel/pfandrecht-capititel.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-recht-rubrik',
  templateUrl: './recht-rubrik.component.html',
  styleUrls: ['./recht-rubrik.component.scss'],
  imports: [
    RubrikComponent,
    StandardrechtBelastungenComponent,
    RechtPerimeterComponent,
    HaengigeGeschaefteAuftraegeComponent,
    PfandrechtBelastungenComponent,
    PfandrechtGlaeubigerComponent,
    PfandrechtSchuldnerComponent,
    PfandrechtCapititelComponent,
    TranslatePipe
  ]
})
export class RechtRubrikComponent {
  @Input()
  public item: RechtRubrik;

  @Input()
  public rechtVersionId: RechtVersionId;

  @Input()
  public hasRight = true;
  standardrechtPerimeter: Array<GrundstueckId>;
  pfandrechtPerimeter: Array<GrundstueckId>;

  _standardrecht: StandardrechtMasterDetailEntryMeta;

  @Input()
  set standardrecht(value: StandardrechtMasterDetailEntryMeta) {
    if (!value) {
      return;
    }
    this._standardrecht = value;
    this.standardrechtPerimeter = value.perimeter.map((entry) => entry.id);
  }

  _pfandrecht: PfandrechtMasterDetailEntryMeta;

  @Input()
  set pfandrecht(value: PfandrechtMasterDetailEntryMeta) {
    if (!value) {
      return;
    }
    this._pfandrecht = value;
    this.pfandrechtPerimeter = value.perimeter.map((entry) => entry.id);
  }
}
